import { createContainer } from "unstated-next";
import useRepository from "./useRepository";
import { useEffect } from "react";
import { useErrorHandler } from "./useErrorHandler";
import { SessionRequest } from "@travello/grpc-api/js/user_pb";
import { Subscription } from "rxjs";

import { useAuth } from "../auth/useAuth";
import { isForeground, shouldHandleVisibilityChange } from "@/utils/utils";

/* eslint-disable react-hooks/exhaustive-deps */

const useSession_ = () => {
  const { session$ } = useRepository();
  const { handleError } = useErrorHandler();
  const [{ userId }] = useAuth();

  const subscribeToSession = (start: boolean) => {
    const sessionType = start
      ? SessionRequest.SessionRequestType.START
      : SessionRequest.SessionRequestType.END;

    return session$({
      sessionType
    }).subscribe({
      error: handleError
    });
  };

  useEffect(() => {
    const Visibility = require("visibilityjs");

    let s: Subscription, listener: number;
    if (userId) {
      s = subscribeToSession(isForeground());
      const handleChange = () => {
        if (s) s.unsubscribe();
        if (!shouldHandleVisibilityChange()) {
          return;
        }
        s = subscribeToSession(isForeground());
      };

      listener = Visibility.change(handleChange) as number;
    }

    return function cleanup() {
      if (s) {
        s.unsubscribe();
      }
      if (userId) {
        s = subscribeToSession(false);
      }
      Visibility.unbind(listener);
    };
  }, [userId]);
};

const SessionState = createContainer(useSession_);
SessionState.Provider.displayName = "SessionState.Provider";
export default SessionState.Provider;
